import { type } from "../../types/types";

export default function reducer(
  state = { vendorStore: {}, secondaryBanners: [], primaryBanners: [] },
  action
) {
  switch (action.type) {
    case type.SET_VENDOR_STORE:
      return { ...state, ...action.vendorStore };
    default:
      return state;
  }
}
